import { Component, Input } from "@angular/core";
import { Genre } from "src/app/inventory/genre/genre";
import { GenreService } from "src/app/inventory/genre/genre.service";
import { CriteriaSearchComponent } from "src/app/util/search/criteria/criteria-search.component";

@Component({
  selector: 'genre-search-criteria',
  styleUrls: ['../../../../util/search/criteria/criteria-search.component.css'],
  templateUrl: '../../../../util/search/criteria/criteria-search.component.html'
})
export class GenreSearchCriteriaComponent extends CriteriaSearchComponent<Genre> {
  @Input()
  public loading!: boolean;
  
  constructor(genreService: GenreService) {
    super("Genre", query => genreService.findByNameFrLike(query));
  }

  formatResult(result: Genre): string {
    return result.nameFr + " - " + result.themaCode;
  }

  formatResultsMetadataLabel(): string {
    return "genre(s) affiché(s) sur";
  }
}